import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable } from 'rxjs';

export interface User {
  fullname: string;
  cwid: string;
  firstname: string;
  lastname: string;
  email: string;
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly currentUserSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);
  decodedToken: any;
  isBrowser: boolean;
  location: Location | undefined;

  constructor ( @Inject(DOCUMENT) private readonly dom: Document,
  @Inject(PLATFORM_ID) private readonly platformId: Object) {
  this.isBrowser = isPlatformBrowser(platformId);
  if (this.isBrowser) {
    this.location = window.location;
  }
  }

  login(accessToken: string = "",idToken: string = "",refreshToken: string = ""): void {
    // For demo purposes, assume authentication is successful.
    // Login Method tobe implemented
    let user: User;
    if(this.location!==undefined && accessToken != "" && !this.location.href.includes('localhost')){      
      sessionStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('id_token', idToken);
      sessionStorage.setItem('refresh_token', refreshToken);
      const helper = new JwtHelperService();
      this.decodedToken = helper.decodeToken( idToken );
      user = {  //For Testing purpose and untill token is configured values hardcoded
        fullname: this.decodedToken.name,
        cwid: this.decodedToken['https://bayer.com/cwid'],
        lastname: this.decodedToken.family_name,
        firstname: this.decodedToken.given_name,
        email: this.decodedToken.email,
        roles: this.decodedToken.roles,
      };
    }
    else{
      sessionStorage.setItem('access_token', accessToken);
      const helper = new JwtHelperService();
      this.decodedToken = helper.decodeToken( idToken );
      user = {  //For Testing purpose and untill token is configured values hardcoded
        fullname: this.decodedToken.name,
        cwid: this.decodedToken['https://bayer.com/cwid'],
        lastname: this.decodedToken.family_name,
        firstname: this.decodedToken.given_name,
        email: this.decodedToken.email,
        roles: [...this.decodedToken.roles]
      };
    }
    sessionStorage.setItem('user',JSON.stringify(user))
  }

  logout(): void {
    this.currentUserSubject.next(null);
  }

  public get currentUserValue(): any {
    const user: any = sessionStorage.getItem('user');
    if(null == user && !location.href.includes('localhost')){
      window.location.href = '/'
    }
    return JSON.parse(user)
  }

  // public isAuthorized(allowedRoles: string[]): boolean {
  //   const user = this.currentUserValue;
  //   if (!user) return false;
  //   return user.roles.some(role => allowedRoles.includes(role));
  // }
}
